import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { PageHeading, PageShell } from "@/components/layout/PageShell";
import { OrderTypeSelector } from "@/components/order-type/OrderTypeSelector";
import { Spinner } from "@/components/states";
import { useCart } from "@/lib/cart";
import { useI18n } from "@/lib/i18n";
import { orderTypeProductSlug, orderTypeReturnTo } from "@/lib/checkout-model";

export const Route = createFileRoute("/order-type")({
  validateSearch: (search: Record<string, unknown>) => ({
    returnTo: orderTypeReturnTo(search["returnTo"]),
    productSlug: orderTypeProductSlug(search["productSlug"]),
  }),
  component: OrderTypePage,
});

function OrderTypePage() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { hydrated } = useCart();
  const { returnTo, productSlug } = Route.useSearch();

  return (
    <PageShell>
      <PageHeading
        breadcrumbs={[{ label: t("nav.home"), to: "/" }, { label: t("orderType.title") }]}
        back
        backTo={returnTo}
        title={t("orderType.title")}
        description={t("orderType.pageDesc")}
      />
      {hydrated ? (
        <OrderTypeSelector
          confirmLabel={t(returnTo === "/checkout" ? "orderType.backCheckout" : returnTo === "/cart" ? "orderType.backCart" : "orderType.confirm")}
          onDone={() =>
            productSlug
              ? navigate({ to: "/menu/$slug", params: { slug: productSlug } })
              : navigate({ to: returnTo })
          }
        />
      ) : (
        <div className="grid min-h-48 place-items-center" role="status" aria-label={t("common.loading")}>
          <Spinner className="size-7" />
        </div>
      )}
    </PageShell>
  );
}
